import React from 'react'
import { ReactComponent } from './wood.svg'
import { MergeReactElementProps } from '@komune-io/g2-utils'

interface WoodProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', WoodProps>

export const WoodIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#828282' } = props
    return <ReactComponent stroke={color} ref={ref} {...props} />
  }
)
